import { getRoute } from '@/router/helpers';
import { AuthPermission } from '@/lib/services/auth.service';
import { IconType } from '../icon/helpers';

export type SidebarItem = {
  key: string;
  label: string;
  icon?: IconType;
  link?: string;
  target?: string;
  perm?: AuthPermission;
  comingSoon?: boolean;
  parent?: string;
  demo?: boolean;
  noDemo?: boolean;
};

export type SidebarSection = {
  key: string;
  title: string;
  items: SidebarItem[];
  perm?: AuthPermission;
};

export const SidebarSections: SidebarSection[] = [
  {
    key: 'manage',
    title: 'Manage',
    items: [
      {
        key: 'orgs',
        ...getRoute('orgs'),
      },
      {
        key: 'partners',
        ...getRoute('partners'),
        perm: 'super',
      },
    ],
  },
  {
    key: 'configure',
    title: 'Configure',
    items: [
      {
        key: 'partner',
        ...getRoute('partner'),
      },
      {
        key: 'admin-users',
        ...getRoute('admin-users'),
        perm: 'manage-admins',
      },
      {
        key: 'root-users',
        ...getRoute('root-users'),
        perm: 'super',
      },
    ],
  },
];
